module.exports = __webpack_public_path__ + "img/container.03d13aa0.svg";